import conditionalTranslation from "@/mixins/conditionalTranslation";
import birthdayToAge from "@/mixins/birthdayToAge";

function install(Vue) {
  Vue.use(birthdayToAge);
  Vue.use(conditionalTranslation);
}

export default { install };
